module.exports = __webpack_public_path__ + "img/1.60df9a0f.png";